// Module
var code = "<div data-direction=\"<%= direction %>\" class=\"pureSelectScrollButton <%= direction === 1 ? 'down' : 'up' %>\"> <%= direction === 1 ? '&#x25BC' : '&#x25B2' %> </div> ";
// Exports
module.exports = code;